import { PlatformDeviceInfo, type SystemInfoMemory } from "./platform-device-info";
import { PlatformType } from "./platform-type";
import { PlatformUserAgent } from "./platform-user-agent";

export class PlatformAmazon extends PlatformUserAgent {

    constructor() {
        super(PlatformType.Amazon)
    }

    public static matchThisPlatform(): boolean {
        return window.navigator.userAgent.toLowerCase().includes("vega");
    }

    isSupported(): boolean {
        return true;
    }

    async getDeviceInfo(): Promise<PlatformDeviceInfo> {
        return new PlatformDeviceInfo(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any)?.vegaOs?.deviceInfo.macAddress,
            {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                model: (window as any)?.vegaOs?.deviceInfo.model ?? "",
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                manufacturer: (window as any)?.vegaOs?.deviceInfo.manufacturer ?? "",
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                buildVersion: (window as any)?.vegaOs?.deviceInfo.buildVersion ?? "",
            },
            {
                macAddress: "",
                signalStrength: null,
                ssid: "",
                status: "",
            },
            {
                status: "",
                macAddress: "",
                cable: "",
            }
        );

    }
    public getOSVersion(): string | null {
        return null;
    }

    public async getMemoryInfo(): Promise<SystemInfoMemory | null> {
        // TODO: Implement
        return null;
    }

};